import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumFilteringOperation implements BaseEnumType {
  private static allValues: EnumFilteringOperation[] = []; // make sure this is top-most
  
  public static none = new EnumFilteringOperation(0, "None", "enum_filtering_operation_none");
  public static equals = new EnumFilteringOperation(1, "Equals", "enum_filtering_operation_equals");
  public static notEquals = new EnumFilteringOperation(2, "NotEquals", "enum_filtering_operation_not_equals");
  public static lessThan = new EnumFilteringOperation(3, "LessThan", "enum_filtering_operation_less_than");
  public static lessThanOrEquals = new EnumFilteringOperation(4, "LessThanOrEquals", "enum_filtering_operation_less_than_or_equals");
  public static greaterThan = new EnumFilteringOperation(5, "GreaterThan", "enum_filtering_operation_greater_than");
  public static greaterThanOrEquals = new EnumFilteringOperation(6, "GreaterThanOrEquals", "enum_filtering_operation_greater_than_or_equals");
  public static contains = new EnumFilteringOperation(7, "Contains", "enum_filtering_operation_contains");
  public static notContains = new EnumFilteringOperation(8, "NotContains", "enum_filtering_operation_not_contains");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumFilteringOperation.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumFilteringOperation.none; }
  public isEquals() { return this === EnumFilteringOperation.equals; }
  public isNotEquals() { return this === EnumFilteringOperation.notEquals; }
  public isLessThan() { return this === EnumFilteringOperation.lessThan; }
  public isLessThanOrEquals() { return this === EnumFilteringOperation.lessThanOrEquals; }
  public isGreaterThan() { return this === EnumFilteringOperation.greaterThan; }
  public isGreaterThanOrEquals() { return this === EnumFilteringOperation.greaterThanOrEquals; }
  public isContains() { return this === EnumFilteringOperation.contains; }
  public isNotContains() { return this === EnumFilteringOperation.notContains; }

  public static getValues(): readonly EnumFilteringOperation[] {
    return EnumFilteringOperation.allValues;
  }

  public static getValuesExcept0(): readonly EnumFilteringOperation[] {
    return EnumFilteringOperation.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumFilteringOperation {
    const found = EnumFilteringOperation.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumFilteringOperation - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumFilteringOperation): EnumFilteringOperation {
    const found = name ? EnumFilteringOperation.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumFilteringOperation - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumFilteringOperation>): boolean {
    return this.key === other?.key;
  }
}